import project1 from '../images/projectImages/reactwithcss/mememaster.png'
import project2 from '../images/projectImages/reactwithcss/calculator.png'
import project3 from '../images/projectImages/reactwithcss/quizapp.png'
import project4 from '../images/projectImages/reactwithcss/hangman.png'
import project5 from '../images/projectImages/reactwithcss/noteapp.png'
import project6 from '../images/projectImages/reactwithcss/taskFlow.png'
import project7 from '../images/projectImages/reactwithcss/blogPage.png'


const Reactwithcsslist = [
  {
    id: '1',
    projectImage:project1,
    title: 'meme master',
    description: "This is a web app that helps users create their own memes",
    liveDemoLink: "https://jojo588.github.io/Meme-Master/",
    sourceCode: "https://github.com/Jojo588/Meme-Master.git"

  },
  {
    id: '2',
    projectImage: project2,
    title: 'calculator',
    description: "This is a web calculator app that helps users make calculations",
    liveDemoLink: "https://jojo588.github.io/calculatorApp/",
    sourceCode: "https://github.com/Jojo588/calculatorApp.git"

  },
    {
    id: '3',
    projectImage: project3,
    title: 'quiz app',
    description: "This is an online quiz app that test users knowledge",
    liveDemoLink: "https://jojo588.github.io/quizApp/",
    sourceCode: "https://github.com/Jojo588/quizApp.git"

  },
      {
    id: '4',
    projectImage: project4,
    title: 'hangman',
    description: "This is an online hangman game to entertain users",
    liveDemoLink: "https://jojo588.github.io/hangman/",
    sourceCode: "https://github.com/Jojo588/hangman.git"

  },
      {
    id: '5',
    projectImage:project5,
    title: 'note app',
    description: "This is an online note app that enables uses save notes",
    liveDemoLink: "https://jojo588.github.io/noteApp/",
    sourceCode: "https://github.com/Jojo588/noteApp.git"

  },
    {
    id: '6',
    projectImage:project6,
    title: 'taskflow',
    description: "This is a fictional landing page for task management",
    liveDemoLink: "https://tech-landing-page-pxcq.vercel.app/",
    sourceCode: "https://github.com/Jojo588/taskflow.git"

  },
    {
    id: '7',
    projectImage:project7,
    title: 'blogPage',
    description: "This is a landing page for a blog website",
    liveDemoLink: "https://blog-page-fawn.vercel.app/",
    sourceCode: "https://github.com/Jojo588/blogPage.git"

  },

  ];
export default Reactwithcsslist;
